module.exports = __webpack_public_path__ + "img/wechat-qrcode-2.c9ad4fb9.jpg";